Controller.$inject = ['$timeout'];

function Controller($timeout) {
}

export function HuiPageHeader() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui px-4 py-1 hui-page-header"
                          ng-transclude></div>`;
        }
    };
}